import React from "react"
import { Link } from "react-router-dom"

const Menu = props => (
  <nav className = { "main-menu" }>
    <ul>
      {
        props.options.map(option => (
          <li key = { option } >
            <Link
              to = { option === "home" ? "/" : `/${option}` }
              style = {{
                color: "black",
                textDecoration: "none"
              }}
            >
              { option }
            </Link>
          </li>
        ))
      }
    </ul>
  </nav>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js